import React from 'react';
import { withRouter } from 'react-router-dom';
import { Col, FormGroup, Row } from 'react-bootstrap';
import { SaveCancel, Label } from 'fw/components';
import { Form, PasswordBox } from 'fw/forms';
import { PasswordInstructions } from 'areas/shared/components';
import * as FormManager from 'fw/forms/form/FormManager'
import * as API from 'modules/app/API'
import * as App from 'modules/app/App'
import * as Notifications from 'fw/globals/Notifications'
import * as Help from 'modules/app/Help'
import SecurityAnswers from 'areas/public/restorePassword/SecurityAnswers'

class SecurityTab extends React.Component {

	constructor(props) {
		super(props);
		this.state = this.initialState();
	}

	initialState = () => {
		return {
			loading: true,
			getting: true,
			form: {}
		};
	}

	load = () => {
		API.Security.get('/profile/loadSecurity', {},
			{
				success: (r) => {
					this.setState({
						loading: false,
						data: r.data
					});
				}
			});
	}

	get = () => {
		API.Security.get('/profile/getSecurity', {},
			{
				success: (r) => {
					this.setState({
						getting: false,
						form: r.data
					});
				}
			});
	}

	save = () => {
		if (!this.validate())
			return;

		const form = this.state.form;

        let rq = {
            securityAnswers: form.securityAnswers
        };

		if (form.oldPassword && form.oldPassword !== "") {
			Object.assign(rq, {
				oldPassword: form.oldPassword,
				newPassword: form.newPassword
			});
		}

		API.Security.post('/profile/updateSecurity', rq,
			{
				success: (r) => {
					Notifications.success(r.message);
				},
				error: (r) => {
					Notifications.error(r.error.errorMessage);
				}
			});
	}

	validate = () => {
		const form = this.state.form;

		if (form.newPassword !== form.confirmPassword) {
			Notifications.error("The password and confirmation password do not match.");
			return false;
		}

		return true;
	}

	cancel = () => {
		this.props.history.push('/');
	}

	onSubmit = () => {
		this.save();
	}

	onCancel = () => {
		const me = this;
		FormManager.checkUnsavedChanges(function () {
			me.cancel();
		})
	}

	onChange = (form) => {
		this.setState({ form });
	}

	onSecurityAnswersChange = (value) => {
        this._form.update({ securityAnswers: value });
	}
	
	setHelp = () => {
		if (this.props.helpKey)
			Help.setHelp(this.props.helpKey)
		else
			Help.clearHelp();
	}

	componentDidMount() {
		this.load();
		this.get(this.props.selectedId);
		this.setHelp();
	}

	render() {
		if (this.state.loading || this.state.getting)
			return null;

		return (
			<React.Fragment>
				<h2>{App.context().auditUserName}</h2>
				<hr />
				<Form
					onChange={this.onChange}
					onSubmit={this.onSubmit}
					values={this.state.form}
					unsavedChangesWarning={true}
					ref={(form) => this._form = form}>
					<Row>
						<Col md={7}>
							<FormGroup>
								<Label htmlFor="oldPassword" required={this.state.changingPassword}>Current password</Label>
								<PasswordBox 
									name="oldPassword" 
									placeholder="Current password"
									validate={false} 
									required={this.state.changingPassword} />
							</FormGroup>
							<FormGroup>
								<Label htmlFor="newPassword" required={this.state.changingPassword}>New password</Label>
								<PasswordBox 
									name="newPassword" 
									placeholder="New password"
									required={this.state.changingPassword} />
							</FormGroup>
							<FormGroup>
								<Label htmlFor="confirmPassword" required={this.state.changingPassword}>Confirm new password</Label>
								<PasswordBox 
									name="confirmPassword" 
									placeholder="Confirm new password"
									required={this.state.changingPassword} />
							</FormGroup>
						</Col>
						<Col md={5}>
							<PasswordInstructions />
						</Col>
					</Row>
					<hr />
                    <SecurityAnswers
                        securityAnswers={this.state.form.securityAnswers}
                        securityQuestions={this.state.data.securityQuestions}
                        requiredSecurityQuestions={this.state.data.requiredSecurityQuestions}
                        maxSecurityQuestions={this.state.data.maxSecurityQuestions}
                        onChange={this.onSecurityAnswersChange} />
					<br />
					<hr />
					<div className="text-center">
						<hr />
						<SaveCancel onCancel={this.onCancel} />
					</div>
				</Form>
			</React.Fragment>)
	}
}

export default withRouter(SecurityTab);



// WEBPACK FOOTER //
// ./src/areas/main/profile/security/SecurityTab.js